export default "__VITE_ASSET__BkRt7EaN__"